module.exports = __webpack_public_path__ + "static/seamless-screenshots-31c6d42bdd5b4d16064e5ab08476e656.png";